// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"TextArea-cssmodule-wrapper-1CuoM","placeholder":"TextArea-cssmodule-placeholder-1SnsL"};


//////////////////
// WEBPACK FOOTER
// ./components/CommonSet/TextArea.cssmodule.less
// module id = 641
// module chunks = 0